import { Schema } from 'effect';

/**
 * Native release gating — deliberately independent of the OTA schemas next
 * door. OTA decides which JS bundle a binary runs; this decides whether a
 * binary may run at all, and its only remedy is installing a new build from
 * the store. The two never substitute for each other: a bad OTA payload is
 * rolled back with `publish-ota repoint`, because an OTA update does not move
 * the native version this gate compares.
 */

/**
 * Which distribution an install came from. Mirrors the build variants
 * (`prod` / `dev` in apps/mobile/conf-schema.ts): `production` is the App
 * Store and Play builds, `staging` is TestFlight and internal builds. Kept as
 * its own literal rather than reusing OtaChannel so the two can diverge — the
 * name overlap is a coincidence of both having two rings, not a shared
 * concept.
 */
export const MOBILE_RELEASE_CHANNELS = ['staging', 'production'] as const;
export const MobileReleaseChannel = Schema.Literals([
  ...MOBILE_RELEASE_CHANNELS,
]);
export type MobileReleaseChannel = typeof MobileReleaseChannel.Type;

export const MOBILE_RELEASE_PLATFORMS = ['ios', 'android'] as const;
export const MobileReleasePlatform = Schema.Literals([
  ...MOBILE_RELEASE_PLATFORMS,
]);
export type MobileReleasePlatform = typeof MobileReleasePlatform.Type;

/**
 * One to four dot-separated numbers, e.g. `6.1.1` — the shape of
 * `CFBundleShortVersionString` / `versionName`. The store-listing tags this
 * replaces captured any non-space run and validated afterwards; here the
 * pattern IS the contract.
 */
export const DottedVersion = Schema.String.pipe(
  Schema.check(Schema.isPattern(/^\d+(?:\.\d+){0,3}$/)),
).annotate({
  identifier: 'DottedVersion',
  description: 'One to four dot-separated numbers, e.g. 6.1.1.',
});
export type DottedVersion = typeof DottedVersion.Type;
